// src/constants/tenants.js
// New file: Centralizes tenants gender options.

import malesIcon from '../assets/males.png';
import femaleIcon from '../assets/female.png';

export const tenantsOptions = [
  { value: 'males', icon: malesIcon, ar: 'ذكور', en: 'Males' },
  { value: 'females', icon: femaleIcon, ar: 'إناث', en: 'Females' },
]; 